import { useState } from 'react'

/**
 * Player do YouTube.
 *
 * O app não hospeda vídeo (seções 6 e 7): apenas incorpora. Duas
 * escolhas aqui:
 *
 *  · `youtube-nocookie.com` — não grava histórico de visualização
 *    enquanto ela não toca o play.
 *  · O iframe só é criado depois do primeiro toque. Sem isso, uma tela
 *    com dez exercícios carregaria dez players do YouTube de uma vez,
 *    o que no 4G significa esperar muito para ver uma lista.
 */
export function PlayerYouTube({
  youtubeId,
  titulo,
  aoIniciar,
}: {
  youtubeId: string
  titulo: string
  /** Disparado no primeiro toque. Usado para registrar a visualização. */
  aoIniciar?: () => void
}) {
  const [tocando, setTocando] = useState(false)

  function iniciar() {
    setTocando(true)
    aoIniciar?.()
  }

  const capa = `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`
  const src =
    `https://www.youtube-nocookie.com/embed/${youtubeId}` +
    '?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=pt-BR'

  if (!tocando) {
    return (
      <button
        type="button"
        onClick={iniciar}
        className="group relative aspect-video w-full overflow-hidden rounded-[var(--radius-cartao)] bg-marrom"
        aria-label={`Assistir: ${titulo}`}
      >
        <img
          src={capa}
          alt=""
          loading="lazy"
          className="size-full object-cover opacity-85 transition-opacity group-hover:opacity-100"
        />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex size-16 items-center justify-center rounded-full bg-coral shadow-[var(--shadow-elevado)] transition-transform group-active:scale-95">
            <svg viewBox="0 0 24 24" className="ml-1 size-7 fill-white" aria-hidden>
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </span>
      </button>
    )
  }

  return (
    <div className="aspect-video w-full overflow-hidden rounded-[var(--radius-cartao)] bg-marrom">
      <iframe
        src={src}
        title={titulo}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="size-full border-0"
      />
    </div>
  )
}
